import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { INQUIRY_DETAIL_URL, INQUIRY_DELETE_URL } from "../../utils/urls";
import instance from "../../services/services";
import PopupLoginError from "../../components/Popup/LoginError";
import { useLanguage } from "../../hooks/useLanguage";

function CustomizingDetail({formType = 'customizing'}) {
  const { t } = useLanguage();
  const { b_seq } = useParams(); // URL에서 b_seq 파라미터 가져오기
  const navigate = useNavigate();
  const [detailData, setDetailData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [file, setFile] = useState([]);
  const [isPopupOpen, setIsPopupOpen] = useState(false);

  // 커스터마이징 상세 조회
  useEffect(() => {
    const fetchDetailData = async () => {
      try {
        const response = await instance.post(INQUIRY_DETAIL_URL, {
          b_seq: b_seq,
        });
        setDetailData(response.data.data.data); 
        setFile(response.data.data.files);

      } catch (error) {
        console.error("1:1문의 상세 조회 실패:", error);
        setError(error.message);
      } finally {
        setLoading(false);
      }
    };
  
    if (b_seq) {
      fetchDetailData();
    }
  }, [b_seq]);

  const handleBackToList = () => {
    navigate(`/community/${formType}`);
  };

  if (loading) {
    return <div>로딩 중...</div>;
  }

  if (error) {
    return <div>에러가 발생했습니다: {error}</div>;
  }

  if (!detailData) {
    return <div>데이터를 찾을 수 없습니다.</div>;
  }

  const handleDelete = async () => {
    try {
      const response = await instance.post(INQUIRY_DELETE_URL, {
        b_seq: b_seq
      });
      
      if (response.data.success) {
        setIsPopupOpen({
          message: '문의가 삭제되었습니다.',
          action: 'navigate_inquiry'
        });
      } else {
        setIsPopupOpen('문의 삭제에 실패했습니다.');
      }
    } catch (error) {
      console.error('문의 삭제 오류:', error);
      setIsPopupOpen('문의 삭제 중 오류가 발생했습니다.');
    }
  };

  // 팝업 확인 버튼 클릭 핸들러
  const handleConfirm = () => {
    if (isPopupOpen.action === 'navigate_inquiry') {
      navigate('/community/customizing'); 
    }
    setIsPopupOpen(false); // 팝업 닫기
  };

  const handleEdit = () => {
    navigate(`/community/customizing/write?b_seq=${b_seq}`);
  };

  return (
    <div className="board_container">
      <h3 className="commu_title">{t('customization')}</h3>

      <div className="board_container form_board board_detail">
        <li className="board_item">
          <div className="board_box flex-4 column">
            <h6 className="title flex-center-4 b1-2">
              <span>{detailData.subject}</span>
            </h6>
            <div className="board_info board_line">
              <span className="text_small g-70">{detailData.regist_date}</span>
              <span className="text_small g-70">{detailData.board_type}</span>
              <span className="text_small g-70">{detailData.userid}</span>
            </div>
          </div>

          {/* 답변상태 뱃지 */}
          <div className="board_status">
            {detailData.re_contents ? (
              <span className="badge g-100">{t('answer_completed')}</span>
            ) : (
              <span className="badge yellow">{t('answer_pending')}</span>
            )}
          </div>
        </li>

        <div className="board_contents unset_box">
          <div dangerouslySetInnerHTML={{ __html: detailData?.contents }}></div>
          {file && file.length > 0 && (
            <div className="board_bottom attach_file">
              <div className="img_attach_box">
                <ul className="preview_list">
                  {file.map((file, index) => (
                    <li key={index} className="default_btn ic_lg">
                      <img
                        className="object-cover"
                        src={file?.new_filepath}
                        alt={`첨부 이미지 ${index + 1}`}
                        loading="lazy"
                      />
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          )}  
        </div>

        {/* 수정, 삭제 버튼 > 답변대기에서만 보이게 */}
        {detailData.re_contents === null && (
        <div className="btn_group edit_box">
          <button type="button" className="default_btn xs white" onClick={handleEdit}>
            {t('modify')}
          </button>
          <button type="button" className="default_btn xs white" onClick={handleDelete}>
            {t('delete')}
          </button>
        </div>
        )}


        {/* 답변 > 답변완료 에서 보이게 */}
        {detailData.re_contents && (
          <div className="board_answer">
            <div dangerouslySetInnerHTML={{ __html: detailData?.re_contents }}></div>
          </div>
        )}

      </div>
      <div className="submit_box mt_32">
        <button className="default_btn white lg" onClick={handleBackToList}>
          {t('list_0617')}
        </button>
      </div>
      <PopupLoginError isPopup={isPopupOpen} setIsPopup={setIsPopupOpen} onConfirm={handleConfirm}/>

    </div>
  );
}

export default CustomizingDetail;